import React, { useState, useEffect } from "react";
import LinkToDashboard from "../../../../../../components/bankAccount/modals/linkToDashboard";
import DeleteConnectionMulti from "./deleteConnectionMulti";
import LogManualAccount from "../../../../../../components/bankAccount/logManualAccount";
import ConnectMoreAccounts from "../../../../../../components/bankAccount/modals/connectMoreAccounts";
import ExportConnectionsDetailsModal from "./ExportConnectionsDetailsModal";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import UploadSFTPFilesModal from "../../../manageConnectionsDetails/uploadSFTPFilesModal";
import PermissionGate from "../../../../../../helpers/PermissionGate";
import Tooltip  from "@mui/material/Tooltip";
import Typography from '@mui/material/Typography'

function ExternalConnectionsDetailsTableDropdown(props) {
  const [showLinkToDashboardModal, setShowLinkToDashboardModal] =
    useState(false);
  const [showDeleteConnectionMultiModal, setShowDeleteConnectionMultiModal] =
    useState(false);
  const [showConnectMoreAccountsModal, setShowConnectMoreAccountsModal] =
    useState(false);
  const [exportModalVisible, setExportModalVisible] = useState(false)

  const onManualUpdateSuccess = (record) => {
    props.setExternalConnections((prevState) => {
      return [...prevState, record];
    });
  };

  const formatButton = (body, tooltip, variant, color, onClick, disabled) => {
    const btn = (
      <Button
        color={color}
        variant={variant}
        onClick={onClick}
        sx={{ fontSize: 14, textTransform: 'none' }}
        disabled={disabled}
        fullWidth
      >
        {body}
      </Button>
    )
    return tooltip ? (
      <Tooltip arrow title={<Typography>{tooltip}</Typography>}>
        <span>
          {btn}
        </span>
      </Tooltip>
    ) : (
      btn
    )
  }


  return (
    <Stack direction="column" spacing={1}>

      {props.source === "FT" ? (
        <UploadSFTPFilesModal
          sftpServerId={props.sourceGroupId}
          bankName={props.institutionName}
          loading={props.institutionName === ""}
          onUploadSuccess={props.onSFTPUploadSuccess}
        />
      ) : (
        <PermissionGate
          requiredRole='dashboardEditor'
          readOnly={
            <Button
              sx={{ fontSize: 14, textTransform: 'none' }}
              disabled
              variant='contained'
              fullWidth
            >
              Connect More Accounts
            </Button>
          }
          toolTipText='Only admins and dashboard editors may connect more accounts'
          spanSettings={{ style: { width: '100%' }}}
        >
          {formatButton(
            'Connect More Accounts',
            undefined,
            'contained',
            'primary',
            () => {
              setShowConnectMoreAccountsModal(true)
            },
            false
          )}
        </PermissionGate>
      )}

      {formatButton(
        "Export",
        undefined,
        "outlined",
        "primary",
        () => {
          if (!props.tableData || props.tableData.length === 0) {
            return;
          }
          setExportModalVisible(true);
        },
        !props.tableData || props.tableData.length === 0
      )}

      {false && formatButton(
        "Link to Dashboard",
        props.selectedRows.length === 0 ? "No accounts selected" : undefined,
        "outlined",
        "primary",
        () => {
          if (!props.selectedRows || props.selectedRows.length === 0) {
            return;
          }
          setShowLinkToDashboardModal(true);
        },
        props.selectedRows.length === 0
      )}


      {
        false &&
        <a>
          <LogManualAccount
            button={"Add Manual Account"}
            logManualAccountSuccess={onManualUpdateSuccess}
          />
        </a>
      }

      {showDeleteConnectionMultiModal && (
        <DeleteConnectionMulti
          visible={showDeleteConnectionMultiModal}
          handleCancelModal={() => setShowDeleteConnectionMultiModal(false)}
          selectedRows={props.selectedRows}
          onSuccess={props.onDeleteConnectionsSuccess}
        />
      )}

      {showLinkToDashboardModal && (
        <LinkToDashboard
          visible={showLinkToDashboardModal}
          handleCancelModal={() => setShowLinkToDashboardModal(false)}
          selectedRows={props.selectedRows}
          subPortfolios={props.subPortfolios}
          unlinkedProperties={props.unlinkedProperties}
          onSuccess={props.onLinkToDashboardSuccess}
          source={props.source}
          sourceGroupId={props.sourceGroupId}
          groups={props.groups}
          flattenedTags={props.flattenedTags}
          flattenedTagsLoading={props.flattenedTagsLoading}
          groupsLoading={props.groupsLoading}
        />
      )}

      {showConnectMoreAccountsModal && (
        <ConnectMoreAccounts
          visible={showConnectMoreAccountsModal}
          handleCancelModal={() => setShowConnectMoreAccountsModal(false)}
          plaidAccessTokenOnSuccess={props.plaidAccessTokenOnSuccess}
          sourceGroupId={props.sourceGroupId}
          source={props.source}
        />
      )}

      {exportModalVisible && (
        <ExportConnectionsDetailsModal
          tableData={props.tableData}
          exportModalVisible={exportModalVisible}
          handleCancelModal={() => setExportModalVisible(false)}
        />
      )}
    </Stack>
  );
}

export default ExternalConnectionsDetailsTableDropdown;
